import { DonationData } from "@/types/donation";
import { Order } from "@/types/order";
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface StoreState {
  orderForm: Order;
  donationData: DonationData;
  open: boolean | undefined;
  updateOrderForm: (updates: Order) => void; // eslint-disable-line
  updateDonationData: (updates: Partial<DonationData>) => void; // eslint-disable-line
  toogleOpen: () => void;
  resetAll: () => void;
  coupon: string;
  setCoupon: (coupon: string) => void; // eslint-disable-line
  removeCoupon: () => void;
}

const initialState: Pick<
  StoreState,
  "orderForm" | "donationData" | "open" | "coupon"
> = {
  orderForm: undefined as unknown as Order,
  donationData: {},
  open: undefined,
  coupon: ""
};

export const useStore = create<StoreState>()(
  persist(
    (set) => ({
      ...initialState,
      updateOrderForm: (updates: Order) =>
        set(() => ({
          orderForm: updates
        })),
      updateDonationData: (updates: Partial<DonationData>) =>
        set((state) => ({
          donationData: { ...state.donationData, ...updates }
        })),
      toogleOpen: () => set((state) => ({ open: !state.open })),
      resetAll: () => set(initialState),
      coupon: "",
      setCoupon: (coupon: string) =>
        set(() => ({
          coupon
        })),
      removeCoupon: () =>
        set(() => ({
          coupon: ""
        }))
    }),
    {
      name: "persist:root",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => {
        return { ...state, open: undefined };
      },
      skipHydration: typeof window === "undefined"
    }
  )
);
